module.exports = __webpack_public_path__ + "img/diners.d03222e.png";